import React, { FC } from 'react';
import DesktopTooltip from 'generic/DesktopTooltip';
import nanoid from 'nanoid';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import icon from './priorityIcon.svg';
import { PriorityIconStyles } from './PriorityIconStyles';

interface Props {
  className?: string;
}

const PriorityIcon: FC<Props> = observer(({ className }) => {
  const {
    appStore: { isDesktop, isLaptop },
  } = useStores();

  const uniqueID = nanoid();
  const id = `priority-icon-${uniqueID}`;

  const height = isDesktop || isLaptop ? 15 : 13;

  return (
    <PriorityIconStyles className={className}>
      <img height={height} className={'icon'} src={icon} alt="truckmarket" data-tip data-for={id} />
      <DesktopTooltip id={id} effect="solid" place="top">
        К объявлению применена услуга
        <br />
        &quot;Приоритетный показ&quot;
      </DesktopTooltip>
    </PriorityIconStyles>
  );
});

export default PriorityIcon;
